import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function CalendarSchedule({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>CalendarSchedule</title>
      <path
        d="M20 10V7C20 5.89543 19.1046 5 18 5H6C4.89543 5 4 5.89543 4 7V10M20 10H4M20 10V11.75M4 10V19C4 20.1046 4.89543 21 6 21H12M8 3V7M16 3V7"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <g clipPath="url(#clip0_4613_7404)">
        <circle
          cx="18"
          cy="18"
          r="3.75"
          stroke={color ?? 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 16.5V18.0002L19.5 18.5"
          stroke={color ?? 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4613_7404">
          <rect width="10" height="10" fill="white" transform="translate(13 13)" />
        </clipPath>
      </defs>
    </svg>
  );
}
